import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CommonConstants from '../utils/common.constants';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private http: HttpClient) { }

  changePassword(data : any) : Observable<any>{
    return this.http.post(CommonConstants.CHANGE_PASSWORD, data);
  }
}
